import UserService from "./UserService";
import kcUser from "./keycloak.js";
import Keycloak from "keycloak-js";

export function gotoLogout() {
  const kcConfig: any = kcUser;
  const _Kc: any = new Keycloak(kcConfig);
  UserService.doLogout();
}
